export function ComplianceFooter() {
  return (
    <footer className="bg-muted border-t border-border px-6 py-6">
      <div className="max-w-5xl mx-auto">
        <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wide mb-2">
          Important investor information
        </p>
        <p className="text-xs text-muted-foreground leading-relaxed">
          Past performance is not indicative of future results.{' '}
          All offerings are subject to the Private Placement Memorandum (PPM).{' '}
          Accredited investor status required. Open1031 verifies accreditation status before any subscription.{' '}
          Open1031 acts as a Registered Investment Adviser. See Form ADV at{' '}
          <a
            href="/adv"
            className="underline hover:text-foreground transition-colors"
          >
            /adv
          </a>
          .
        </p>
      </div>
    </footer>
  )
}
